import React from "react";
import { Drawer } from "antd";

import { WhatsAppConversationPanel } from "./WhatsAppConversationPanel";

interface WhatsAppConversationDrawerProps {
  open: boolean;
  onClose: () => void;
  companyId: number | string;
  companyType: string;
  leadResponseId: number | null;
  title?: string;
}

const DRAWER_WIDTH = 560;

export const WhatsAppConversationDrawer: React.FC<WhatsAppConversationDrawerProps> = ({
  open,
  onClose,
  companyId,
  companyType,
  leadResponseId,
  title = "WhatsApp Conversation",
}) => (
  <Drawer
    title={title}
    open={open}
    onClose={onClose}
    width={DRAWER_WIDTH}
    destroyOnClose
    styles={{ body: { padding: 12 } }}>
    {leadResponseId && (
      <WhatsAppConversationPanel
        companyId={companyId}
        companyType={companyType}
        leadResponseId={leadResponseId}
        height="100%"
      />
    )}
  </Drawer>
);
